enum TipStyle {
    Point = "point",
    Arrow = "arrow"
}

export default TipStyle;
